var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pdf-item"},[_c('header',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v("专精特新小巨人测评报告")]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.companyName))])]),_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.page)?_c('footer',{staticClass:"footer"},[_vm._v(_vm._s(_vm.page))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }